// TODO #4279: Remove after React rollout is complete
import { useMemo } from 'react'
import { Flex, useDisclosure } from '@chakra-ui/react'

import { FormAuthType, FormResponseMode } from '~shared/types'

import { noPrintCss } from '~utils/noPrintCss'

import { PublicFeedbackModal } from '~features/env/PublicFeedbackModal'
import { useEnv } from '~features/env/queries'

type PublicSwitchEnvMessageProps = {
  responseMode?: FormResponseMode
  isAuthRequired: boolean
  authType?: FormAuthType
}

export const PublicSwitchEnvMessage = ({
  responseMode,
  isAuthRequired,
  authType,
}: PublicSwitchEnvMessageProps): JSX.Element | null => {
  const { isOpen, onClose } = useDisclosure()

  const {
    data: {
      respondentRolloutEmail,
      respondentRolloutStorage,
      removeRespondentsInfoboxThreshold,
    } = {},
  } = useEnv()

  const switchEnvRolloutPercentage = useMemo(
    () =>
      responseMode === FormResponseMode.Email
        ? respondentRolloutEmail
        : respondentRolloutStorage,
    [responseMode, respondentRolloutEmail, respondentRolloutStorage],
  )

  // Remove the switch env message if the React rollout for public form respondents is => threshold
  const showSwitchEnvMessage = useMemo(
    () =>
      !!(
        switchEnvRolloutPercentage &&
        removeRespondentsInfoboxThreshold &&
        switchEnvRolloutPercentage < removeRespondentsInfoboxThreshold
      ),
    [switchEnvRolloutPercentage, removeRespondentsInfoboxThreshold],
  )

  if (!showSwitchEnvMessage) return null

  return (
    <Flex
      mt={isAuthRequired ? undefined : '-2.5rem'}
      justify="center"
      sx={noPrintCss}
    >
      <PublicFeedbackModal
        isOpen={isOpen}
        onClose={onClose}
        responseMode={responseMode}
        authType={authType}
      />
    </Flex>
  )
}
